var elementAnimationObject = function elementAnimationObject() {
  return [{
    initialAttr: {
      opacity: 0
    },
    finalAttr: {
      opacity: 1
    },
    slot: 'initial'
  }];
};

export default {
  "initial.extension.annotation": function initialExtensionAnnotation() {
    return {
      "polypath.appearing": elementAnimationObject,
      "text.appearing": elementAnimationObject,
      "image.appearing": elementAnimationObject,
      "ellipse.appearing": elementAnimationObject,
      "ringpath.appearing": elementAnimationObject,
      "path.appearing": elementAnimationObject,
      "rect.appearing": elementAnimationObject,
      "*": null
    };
  }
};